import React from 'react'
import BreadCrumComponent from '../BreadCrumComponent';
import img_success from '../../../assets/images/ilustraciones/img-success.svg';
import img_error from '../../../assets/images/ilustraciones/img-error.svg'
import ModalLogs from './ModalLogs';

class AvisoCreacionTipoDocumento extends React.Component {

    constructor(props) {
        super(props);

        let data = props.location.state.data;
        let resultado = props.match.params.resultado
        let extension = data?.formato?.extension 

        const { tipoAccion } = props.match.params;

        this.state = {
            resultado: resultado,
            nombreTipoDocumento: data?.nombre,
            formatoImportacion: extension,
            errors: data?.errors,
            mostrarLogErrores: false,
            tipoAccion,
        };

        this.modalRef = React.createRef();

        this.handleContinuar = this.handleContinuar.bind(this);
    }

    limpiarStorage() {
        localStorage.removeItem('resultadoImportacionTipoDocumento');
    }

    handleContinuar = () => {
        this.limpiarStorage();
        this.props.history.push('/configuracion/tipo-documento');
    }


    componentWillUnmount() {
        this.limpiarStorage();
    }

    handleVerErrores = () => {
        this.setState({ mostrarLogErrores: true })
    }

    renderVentanaExito = () => {
        return (
            <div className="container-flex container-md">
                <div className="col">
                    <h1 className="section__subtitle-sm"> {this.state.tipoAccion !== 'editar' ? "¡Tipo de documento creado con éxito!"  : "¡Tipo documento editado con éxito!" }  </h1>
                    <div className="card">
                        <h3 className="card-title"> Aquí tienes un resumen</h3>
                        <div className="card-info">
                            <span className="label"> Nombre del tipo de documento </span>
                            <span className="txt"> {this.state.nombreTipoDocumento} </span>
                        </div>
                        <div className="card-info">
                            <span className="label"> Formato de importacion </span>
                            <span className="txt"> {this.state.formatoImportacion} </span>
                        </div>
                    </div>

                    <div className="actions">
                        <button onClick={this.handleContinuar} className="btn-medium btn-primary">Finalizar</button>

                    </div>
                </div>

                <div className="col">
                    <div className="illustration">
                        <img src={img_success} className="img-fluid" alt="accion_success" />
                    </div>
                </div>
            </div>
        );
    }

    renderVentanaError = () => {
        return (
            <div className="container-flex container-md">
                <div className="col">
                    <h1 className="section__subtitle-sm"> Ha ocurrido un error </h1>
                    <div className="card card-flex">

                        <h3 className="card-title"> Aquí tienes un resumen</h3>
                        <div className="card-info">
                            <span className="label"> Nombre del tipo de documento </span>
                            <span className="txt"> {this.state.nombreTipoDocumento} </span>
                        </div>
                        <div className="card-info">
                            <span className="label"> Formato de importacion </span>
                            <span className="txt"> {this.state.formatoImportacion} </span>
                        </div>

                        <div className="card-actions">
                            <button onClick={this.handleVerErrores} className="btn-medium btn-primary-outline open-dialog" data-dialog="modal-logs"> Ver Log de Errores </button>
                        </div>
                    </div>
                </div>


                <div className="col">
                    <div className="illustration">
                        <img src={img_error} className="img-fluid" alt="accion_error" />
                    </div>
                </div>
            </div>
        )
    }


    render() {

        return (
            <div className="template-base">
                <BreadCrumComponent
                    backUrl="/configuracion/tipo-documento"
                    breadcrumbs={
                        [
                            { label: 'Configuracion', path: '/configuracion/tipo-documento' },
                            { label: 'Nuevo Tipo de documeto', path: '/configuracion/tipo-documento/nuevo' },
                            { label:  this.props.match.params.tipoAccion !== 'editar' ? 'Resultados de la creacion' : 'Resultados de la edicion', path: '' },
                        ]
                    }
                />
                <div className="wrapperContent">
                    <div className="component-advice">
                        <div className="page-container">
                            {this.state.resultado === 'error'
                                ? this.renderVentanaError()
                                : this.renderVentanaExito()
                            }
                        </div>
                    </div >
                    {
                        this.state.resultado == 'error' &&
                    
                    <ModalLogs
                        ref={(ref) => (this.modalRef = ref)}
                        abierto={this.state.mostrarLogErrores}
                        onClose={() => this.setState({ mostrarLogErrores: false })}
                        errores={this.state.errors}
                    />
                    }
                </div >
            </div >
        )
    }
}
export default AvisoCreacionTipoDocumento